import React from 'react'
import {connect} from 'react-redux'
import { Container, Row, Col} from 'reactstrap';
import ReportRow from '../components/RefundsRow'
import {formatCurrency} from '../utils/Strings'

const mapStateToProps = state => {  
  return {    
    refunds: state.report.refunds,    
    filter: state.report.refundsFilter,
    infoText: state.report.refundsInfo,     
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return { 
//      onCourseChoose: (ownProps, courseIdx) => {        
//        dispatch(setCourse(courseIdx))
//      },
//    onGetCourses: (ownProps) => {          
//      dispatch(fetchCourses(ownProps.agentLogin))
//    },    
  }
}

class ReportList extends React.Component{
  constructor (props) {
    super(props)
    this.state = {      
//      onCourseChoose: props.onCourseChoose,     
    };
//    this.handleCourseChoose = this.handleCourseChoose.bind(this);
  }
//  handleCourseChoose(idx){
//    //alert('Wybrano ' + idx)
//    this.state.onCourseChoose(this.state, idx)
//  }
  renderInfoText() {
    return (
      <p className="center"><br/>{this.props.infoText}</p>
    )
  }
  render() {
    if (this.props.infoText.length>0)
      return this.renderInfoText()

    if (this.props.refunds.length>0){
      var qtyNormalSum=0
      var qtyReducedSum=0
      var totalRefundSum=0.00
      var totalDeductionSum=0.00
      var totalRefundAgentSum=0.00
      for(var i=0; i<this.props.refunds.length; i++){
        var r=this.props.refunds[i]
        if (!r.isCanceled){
          qtyNormalSum += parseInt(r.qtyNormal,10)
          qtyReducedSum += parseInt(r.qtyReduced, 10)
          totalRefundSum += parseFloat(r.refundPrice)
          if (r.refundDeduction>0){
            totalDeductionSum += parseFloat(r.refundDeduction)
            totalRefundAgentSum += parseFloat(r.refundAgent)
          }
        }
      }
      var strQty=''
      if (qtyNormalSum>0)
        strQty += qtyNormalSum + "N "
      if (qtyReducedSum>0)
        strQty += qtyReducedSum + "U"
      var strRefundDeduction=''
      if (totalDeductionSum>0){
        strRefundDeduction = formatCurrency(totalDeductionSum)
        if (totalRefundAgentSum>0)
          strRefundDeduction +=' /' + formatCurrency(totalRefundAgentSum)
        strRefundDeduction = '(' + strRefundDeduction + ')'
      }
        
      return (      
        <Container fluid={true} className="defList">
          <h3>Lista zwrotów</h3>
          {this.props.refunds.map((refund, index) => (            
            <ReportRow 
              key={index} 
              index={index}
              refund={refund}                
            />
          ))}
          <Row className="align-items-right sumRow ">
            <Col md="10" xs="3">
            RAZEM:
            </Col>
            <Col md="1" xs="1">
            {strQty}
            </Col>
            <Col md="1" xs="2" className="right">
            {formatCurrency(totalRefundSum)}
            </Col>
            <Col md="12" xs="12" className="right">
            {strRefundDeduction}
            </Col>
          </Row>
        </Container>
      )
    }
    else
      return this.renderInfoText()
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportList)    


// WEBPACK FOOTER //
// ./src/containers/RefundsList.js